import { render, staticRenderFns } from "./MastheadItem.vue?vue&type=template&id=6c18f5c3&"
import script from "./MastheadItem.vue?vue&type=script&lang=js&"
export * from "./MastheadItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports